import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f17530ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "q-pa-md flex flex-center"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-h6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, " Bio: ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Socials:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Wallet:", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Click to Copy Address to Clipboard")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Favorite Prjcts:", -1))
const _hoisted_9 = { class: "absolute-bottom text-subtitle1 text-center" }

import { useRoute } from 'vue-router';
import { ref, watchEffect } from 'vue'
import copyToClipboard from 'quasar/src/utils/copy-to-clipboard.js';import useQuasar from 'quasar/src/composables/use-quasar.js';
import { requestOptions, server } from '@/utils/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactCard',
  props: ['userToken'],
  setup(__props) {

const props = __props



async function handleCopyClick(value: string) {
    try {
        await copyToClipboard(value)
        return $q.notify({
            color: 'green-10',
            textColor: 'white',
            icon: 'clipboard',
            group: 'saved group',
            message: `Successfully copied to clipboard`,
            position: 'top'

        })

    } catch (err) {
        // console.log(err)
        return $q.notify({
            color: 'red-10',
            textColor: 'white',
            icon: 'warning',
            message: `So that didn't work. . . sorry`,
            position: 'top'

        })
    }


}
const $q = useQuasar();
const loading = ref(true)
const friend = ref()
const route = useRoute()
watchEffect(async () => {
    let newToken = route.params.id || props.userToken
    if (newToken) {
        // console.log({ newToken })
        const response = await fetch(`${server()}user/findByToken`, requestOptions({ token: newToken }))
        if (!response.ok) { return }
        // console.log(await response.json())
        friend.value = await response.json();
        loading.value = false
    }

})

return (_ctx: any,_cache: any) => {
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_Suspense, null, {
    fallback: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_q_circular_progress, {
              indeterminate: "",
              size: "50px",
              color: "indigo",
              class: "q-ma-md"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createBlock(_component_q_card, {
            key: 0,
            id: "contact-card",
            dark: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "flex justify-center greeting full-width" }, {
                default: _withCtx(() => [
                  (friend.value.avatar)
                    ? (_openBlock(), _createBlock(_component_q_avatar, {
                        key: 0,
                        size: "40px"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            id: "avatar",
                            src: friend.value.avatar ? friend.value.avatar : void 0,
                            alt: "User Avatar"
                          }, null, 8, _hoisted_2)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(friend.value.username), 1)
                ]),
                _: 1
              }),
              (friend.value.bio)
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 0,
                    id: "bio-section"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createTextVNode(" " + _toDisplayString(friend.value.bio), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_card_section, { id: "socials-section" }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createVNode(_component_q_btn, {
                    dark: "",
                    flat: "",
                    disable: !friend.value?.discord,
                    label: (_unref($q).screen.gt.xs ? (friend.value.discord ? friend.value.discord : 'Not Available') : void 0),
                    icon: "fab fa-discord",
                    href: `http://www.discordapp.com/user/${friend.value.discordID}`,
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      (friend.value?.discord)
                        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(friend.value?.discord), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["disable", "label", "href"]),
                  _createVNode(_component_q_btn, {
                    dark: "",
                    flat: "",
                    disable: !friend.value?.twitter,
                    label: _unref($q).screen.gt.xs ? (friend.value.twitter ? friend.value.twitter : 'Not Available') : void 0,
                    icon: "fab fa-twitter",
                    href: `http://www.twitter.com/${friend.value.twitter}`,
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      (friend.value?.twitter)
                        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(friend.value.username) + " on Twitter @" + _toDisplayString(friend.value?.twitter), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["disable", "label", "href"]),
                  _createVNode(_component_q_btn, {
                    dark: "",
                    flat: "",
                    disable: !friend.value?.email,
                    label: _unref($q).screen.gt.xs ? (friend.value.email ? friend.value.email : 'Not Available') : void 0,
                    icon: "email",
                    href: `mailto:${friend.value.email}`,
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      (friend.value?.email)
                        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(friend.value.email), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["disable", "label", "href"]),
                  (friend.value?.website)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        dark: "",
                        flat: "",
                        label: _unref($q).screen.gt.xs ? 'Website' : void 0,
                        icon: "language",
                        href: friend.value.website,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(friend.value?.website), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["label", "href"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, { id: "wallet-section" }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createElementVNode("div", {
                    class: "truncate",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleCopyClick(friend.value.wallet)))
                  }, _toDisplayString(friend.value?.wallet), 1),
                  _createVNode(_component_q_tooltip, { "max-width": "300px" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createVNode(_component_q_card_section, { class: "flex fav-section row justify-around" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friend.value?.favorites, (project) => {
                        return (_openBlock(), _createBlock(_component_q_card, {
                          class: "fav-card",
                          align: "center",
                          dark: "",
                          key: project.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_img, {
                              style: {"max-width":"300px","height":"150px"},
                              fit: "cover",
                              ratio: "1",
                              src: project.thumbnail
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, _toDisplayString(project.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["src"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})